import { Component, OnInit } from "@angular/core";
import { MatDialog } from "@angular/material/dialog";
import { Router } from "@angular/router";
import { ConstantsService } from "src/app/services/constants.service";
import { EnviornmentSelectionComponent } from "../enviornment-selection.component";

@Component({
  selector: 'app-user-preferences',
  templateUrl: './user-preference.component.html',
  styleUrls: ['./user-preference.component.scss']
})
export class UserPreferenceComponent implements OnInit {

  constructor(
    private route: Router,
    private dialog: MatDialog,
    private constantsService: ConstantsService
  ) { }

  ngOnInit() {
    this.openEnvPopup();
  }

  openEnvPopup() {
    let dialogRef = this.dialog.open(EnviornmentSelectionComponent, {
      width: this.constantsService.SMALL_DIALOG_BOX_WIDTH,
      disableClose: this.constantsService.DIALOG_DISABLE_CLOSE,
      data: { changePreference: true }
    });

    dialogRef.afterClosed().subscribe((value) => {
      if (value) {
        this.getModuleList();
      }
    });
  }

  getModuleList() {
    this.route.navigate([`aggregation/process-management`]);
    return
  }
}